import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'

// Audience
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { t, t2 } from '@/@core/libs/i18n/utils'
import { $themeConfig } from '@themeConfig'

export default function useAudienceList() {
  // Use toast
  const toast = useToast()

  const refAudienceListTable = ref(null)
  const lineOa = computed(() => store.state.lineapi.lineOa)

  const msgAudienceList = {
    errorfetch: t2('Error fetching {module} list', { module: t('Audience') }),
    id: `${t('ID')}`,
    type: `${t('Type')}`,
    name: `${t('Name')}`,
    json: `${t('JSON Data')}`,
    actions: t('Actions'),
  }

  // Table Handlers
  const tableColumns = [
    { key: 'id', sortable: true, label: msgAudienceList.id },
    { key: 'type', sortable: true, label: msgAudienceList.type },
    { key: 'name', sortable: true, label: msgAudienceList.name },
    { key: 'json', sortable: false, label: msgAudienceList.json },
    { key: 'actions', label: msgAudienceList.actions },
  ]

  const filterList = JSON.parse(localStorage.getItem(`${$themeConfig.app.session}-filter-audience-list`))
  const perPage = ref((filterList != null && filterList.perPage != null) ? filterList.perPage : 10)
  const totalAudiences = ref(0)
  // const currentPage = ref((filterList != null && filterList.page != null) ? filterList.page : 1)
  const currentPage = ref(1)
  const perPageOptions = [2, 5, 10, 25, 50, 100]
  const searchQuery = ref((filterList != null && filterList.q != null) ? filterList.q : '')
  const sortBy = ref((filterList != null && filterList.sortBy != null) ? filterList.sortBy : 'id')
  const isSortDirDesc = ref((filterList != null && filterList.sortDesc != null) ? filterList.sortDesc : true)
  const locale = ref('th')

  const dataMeta = computed(() => {
    const localItemsCount = refAudienceListTable.value ? refAudienceListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalAudiences.value,
    }
  })

  const refetchData = () => {
    if (refAudienceListTable.value !== null) {
      refAudienceListTable.value.refresh()
    }
  }

  watch([currentPage, perPage, searchQuery, locale], () => {
    refetchData()
  })

  const getListAudience = (ctx, callback) => {
    const { id } = JSON.parse(lineOa.value)
    const params = {
      q: searchQuery.value,
      perPage: perPage.value,
      page: currentPage.value,
      sortBy: sortBy.value,
      sortDesc: isSortDirDesc.value,
      language: locale.value,
      lineOaId: id,
    }
    store
      .dispatch('audience-store/getListAudience', params)
      .then(response => {
        const { list, total } = response.data
        callback(list)
        totalAudiences.value = total
        localStorage.setItem(`${$themeConfig.app.session}-filter-audience-list`, JSON.stringify(params))
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: msgAudienceList.errorfetchAudience,
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        },
        {
          position: 'bottom-right',
        })
      })
  }

  return {
    getListAudience,
    tableColumns,
    perPage,
    currentPage,
    totalAudiences,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    locale,
    refAudienceListTable,
    filterList,

    refetchData,
  }
}
